import React, { useEffect } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { vernacularData } from '../data/vernacularData';
import { CONTACT_INFO } from '../constants';
import SEO from '../components/SEO';
import './VernacularPage.css';
import './VernacularInfo.css';

function VernacularPage() {
  const { language } = useParams();
  const data = vernacularData[language];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [language]);

  if (!data) {
    return <Navigate to="/" replace />;
  }

  const handleBookNow = () => {
    const phoneNumber = CONTACT_INFO.PHONE.VALUE;
    const message = data.whatsappMessage;
    window.open(`https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`, '_blank');
  };

  return (
    <div className="vernacular-page">
      <SEO 
        title={data.title}
        description={`${data.headline}. ${data.subheadline} Book ads in ${data.language} newspapers easily via WhatsApp.`}
        keywords={`book ${data.language} newspaper ad, ${data.language} ad booking, ${data.newspapers.map(n => n.name).join(', ')} ad`}
        url={`/ads/${language}`}
        breadcrumbs={[
          { name: 'Home', url: '/' },
          { name: `${data.language} Ads`, url: `/ads/${language}` }
        ]}
      />
      <div className="vernacular-hero">
        <div className="vernacular-hero-content">
          <h1>{data.headline}</h1>
          <p>{data.subheadline}</p>
          <button className="cta-button" onClick={handleBookNow}>
            Book Now via WhatsApp
          </button>
        </div>
      </div>

      <div className="vernacular-content">
        <h2>Popular {data.language} Newspapers</h2>
        <div className="newspaper-grid">
          {data.newspapers.map((paper, index) => (
            <div key={index} className="newspaper-card">
              <img src={paper.logo} alt={`${paper.name} Logo`} />
              <h3>{paper.name}</h3>
            </div>
          ))}
        </div>
      </div>

      <div className="vernacular-info-section">
        <div className="info-container">
          <h2>{data.content?.whyAdvertise || `Why Advertise in ${data.language} Newspapers?`}</h2>
          <div className="info-grid">
            <div className="info-card">
              <h3>{data.content?.targetedReach?.title || '🎯 Targeted Reach'}</h3>
              <p>{data.content?.targetedReach?.desc || `Reach the heart of the ${data.nativeName} speaking community. Regional newspapers have a loyal readership that trusts local news implicitly.`}</p>
            </div>
            <div className="info-card">
              <h3>{data.content?.costEffective?.title || '💰 Cost Effective'}</h3>
              <p>{data.content?.costEffective?.desc || 'Advertising in regional newspapers is often 30-50% cheaper than national English dailies, giving you better ROI for local businesses.'}</p>
            </div>
            <div className="info-card">
              <h3>{data.content?.higherEngagement?.title || '⚡ Higher Engagement'}</h3>
              <p>{data.content?.higherEngagement?.desc || `Readers spend more time on vernacular papers. Your ad in ${data.language} gets more attention and better recall value.`}</p>
            </div>
          </div>

          <div className="booking-steps">
            <h3>{data.content?.howToBook || `How to Book ${data.language} Ads Online?`}</h3>
            <ol>
              <li><strong>{data.content?.steps?.[0]?.title || 'Select Newspaper'}:</strong> {data.content?.steps?.[0]?.desc || `Choose from popular papers like ${data.newspapers[0].name} or ${data.newspapers[1].name}.`}</li>
              <li><strong>{data.content?.steps?.[1]?.title || 'Draft Your Ad'}:</strong> {data.content?.steps?.[1]?.desc || `Write your ad content in ${data.language} or English. We provide free translation help!`}</li>
              <li><strong>{data.content?.steps?.[2]?.title || 'WhatsApp Us'}:</strong> {data.content?.steps?.[2]?.desc || "Click the button below to send your details. We'll share the lowest quote instantly."}</li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  );
}

export default VernacularPage;
